import type { AssetRouter } from "replo-publisher/src/trpc/routers/asset";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: assetRouter,
  client: assetClient,
  utils: assetUtils,
  options: assetOptions,
} = createTrpcRouterConfig<AssetRouter>({
  path: "asset",
  queryClient: getNamespacedQueryClient("asset"),
});

export { assetClient, assetRouter, assetUtils, assetOptions };
